import { render, staticRenderFns } from "./ManualEmailIcon.vue?vue&type=template&id=3c8b8986&"
import script from "./ManualEmailIcon.vue?vue&type=script&lang=js&"
export * from "./ManualEmailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports